"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import styles from './NumberField.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import { Button } from '../Button/Button.mjs';
import 'react';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconChevronDown } from '../Icon/components/icons/IconChevronDown.mjs';
import { IconChevronUp } from '../Icon/components/icons/IconChevronUp.mjs';
import { IconMinus } from '../Icon/components/icons/IconMinus.mjs';
import { IconPlus } from '../Icon/components/icons/IconPlus.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { ReactAriaControlledValueFix } from '../../lib/react/ReactAriaControlledValueFix.mjs';

const NumberField = flowComponent("NumberField", (props) => {
  const {
    children,
    className,
    ref,
    defaultValue,
    isWheelDisabled = true,
    ...rest
  } = props;
  const rootClassName = clsx(formFieldStyles.formField, className);
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsxs(
    Aria.NumberField,
    {
      isWheelDisabled,
      ...rest,
      className: rootClassName,
      children: [
        /* @__PURE__ */ jsxs(Aria.Group, { className: styles.group, children: [
          /* @__PURE__ */ jsxs(
            Button,
            {
              ariaSlot: "decrement",
              className: styles.decrementButton,
              size: "s",
              variant: "plain",
              color: "secondary",
              children: [
                /* @__PURE__ */ jsx(IconChevronDown, {}),
                /* @__PURE__ */ jsx(IconMinus, { className: styles.coarsePointerIcon })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            ReactAriaControlledValueFix,
            {
              inputContext: Aria.InputContext,
              props,
              children: /* @__PURE__ */ jsx(
                Aria.Input,
                {
                  className: styles.input,
                  ref,
                  defaultValue
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs(
            Button,
            {
              ariaSlot: "increment",
              className: styles.incrementButton,
              size: "s",
              variant: "plain",
              color: "secondary",
              children: [
                /* @__PURE__ */ jsx(IconChevronUp, {}),
                /* @__PURE__ */ jsx(IconPlus, { className: styles.coarsePointerIcon })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }),
        /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError })
      ]
    }
  ) });
});

export { NumberField, NumberField as default };
//# sourceMappingURL=NumberField.mjs.map
